<template>
  <div class="PaB-dropdown" v-click-outside="close" :class="dropdownClasses">
    <app-button :label="label" :type="buttonType" :icon="true" :class="['PaB-dropdown-toggle', ...buttonClass]" @click.native="toggle">
      <template slot="after">
        <slot name="icon"></slot>
      </template>
    </app-button>

    <div ref="dropdownContent" class="PaB-dropdown-content" v-if="isOpen" :style="alignment">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.PaB-dropdown {
  display: inline-block;
  z-index: 90;

  &.is-open {
    z-index: 999;
  }
}

.PaB-dropdown-direction {
  &--up {
    .PaB-dropdown-content {
      transform: translateY(1px);
      width: calc(100vw - 30px);
    }
    &.is-open .PaB-dropdown-toggle::after {
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      margin-top: -2px;
    }
  }

  &--down {
    .PaB-dropdown-content {
      transform: translateY(-1px);
      width: calc(100vw - 30px);
    }
    &.is-open .PaB-dropdown-toggle::after {
      bottom: 0;
      left: 0;
      right: 0;
      height: 4px;
      margin-bottom: -2px;
    }
  }

  &--left {
    .PaB-dropdown-content {
      transform: translateX(1px);
    }
    &.is-open .PaB-dropdown-toggle::after {
      top: 0;
      bottom: 0;
      left: 0;
      width: 4px;
      margin-left: -2px;
    }
  }
  &--right {
    .PaB-dropdown-content {
      transform: translateX(-1px);
    }
    &.is-open .PaB-dropdown-toggle::after {
      top: 0;
      bottom: 0;
      right: 0;
      width: 4px;
      margin-right: -2px;
    }
  }
}

.PaB-dropdown--relative {
  position: relative;
  .PaB-dropdown-content {
    width: auto;
  }
}

.PaB-dropdown-toggle {
  position: relative;
  z-index: 2;
  vertical-align: middle;
  height: 100%;
  border-width: 1px;

  .is-open & {
    border: 1px solid #b2b2b2;
    background-color: #f0f0f0;
    border-bottom-color: transparent;

    &::after {
      content: "";
      position: absolute;
      background-color: #f0f0f0;
      display: block;
      z-index: 9;
    }
  }
}

.PaB-dropdown-content {
  border: 1px solid rgba(#7f7f7f, 0.5);
  position: absolute;
  padding: 25px;
  min-width: 100%;
  z-index: 1;
  border-radius: 0 0 5px 5px;
  background: #f0f0f0;
}
</style>

<script>
import AppButton from '@/components/AppButton'

export default {
  name: 'Dropdown',

  props: {
    classes: String,
    buttonClass: String,
    buttonType: String,
    label: String,
    direction: {
      type: Array,
      default: function () {
        return ['down', 'left']
      }
    },
    relative: {
      type: Boolean,
      default: true
    }
  },

  components: {
    AppButton
  },

  data: function () {
    return {
      isOpen: false,
      tempDirection: [...this.direction]
    }
  },

  computed: {
    dropdownClasses () {
      let classes = this.classes ? this.classes : ''
      classes += this.isOpen ? ' is-open' : ''
      classes += this.relative ? ' PaB-dropdown--relative' : ''
      classes += ` PaB-dropdown-direction--${this.tempDirection[0]}`
      return classes
    },
    alignment () {
      const style = {}

      switch (this.tempDirection[0]) {
        case 'up':
          style.bottom = '100%'
          break
        case 'down':
          style.top = '100%'
          break
        case 'left':
          style.right = '100%'
          break
        case 'right':
          style.left = '100%'
          break
        default:
          style.top = '100%'
          break
      }

      switch (this.tempDirection[1]) {
        case 'up':
          style.bottom = '0'
          break
        case 'down':
          style.top = '0'
          break
        case 'left':
          style.right = '0'
          break
        case 'right':
          style.left = '0'
          break
        default:
          style.left = '0'
          break
      }

      return style
    }
  },

  created () {
    this.checkContentBounds()
    window.addEventListener('resize', this.checkContentBounds)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.checkContentBounds)
  },

  methods: {
    toggle: function () {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },
    open: function () {
      this.isOpen = true
      this.$emit('open')
      this.checkContentBounds()
    },
    close: function () {
      this.isOpen = false
      this.$emit('close')
    },
    checkContentBounds: function () {
      this.tempDirection = [...this.direction]

      this.$nextTick(function () {
        const fixedDirection = [...this.tempDirection]
        const el = this.$refs.dropdownContent
        if (!el) { return }
        const bounds = el.getBoundingClientRect()
        if (bounds.left <= 0) {
          if (fixedDirection[0] === 'left') {
            fixedDirection[0] = 'right'
          }
          if (fixedDirection[1] === 'left') {
            fixedDirection[1] = 'right'
          }
        }

        if (bounds.right >= window.innerWidth) {
          if (fixedDirection[0] === 'right') {
            fixedDirection[0] = 'left'
          }
          if (fixedDirection[1] === 'right') {
            fixedDirection[1] = 'left'
          }
        }

        this.tempDirection = fixedDirection
      })
    }
  }
}
</script>
